import styled from 'styled-components';
// import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

const BaseButtonGroup = styled.div<{
  $space?: number;
  $reversed?: boolean;
  $vertical?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $reversed = false, $vertical = false }) =>
    `${$vertical ? 'column' : 'row'}${$reversed ? '-reverse' : ''}`};
  gap: ${({ $space: $size = 16 }) => `${$size}px`};

  > * {
    flex: 1;
  }
`;

export const ButtonGroup = BaseButtonGroup;
